import CompanyContractTagQuery from '@/api/tag/query.js';
import CompanyContractTagCreate from '@/api/tag/create.js';
import CompanyContractTagUpdate from '@/api/tag/update.js';

export const companyContractTag = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    companyContractTags: []
  },
  getters: {
    companyContractTags: state => state.companyContractTags
  },
  mutations: {
    setCompanyContractTags(state, companyContractTags) {
      state.companyContractTags = companyContractTags;
    },
    clear(state) {
      state.companyContractTags = [];
    }
  },
  actions: {
    setCompanyContractTags({ commit }, companyContractTags) {
      commit('setCompanyContractTags', companyContractTags);
    },
    clearCompanyContractTags({ commit }) {
      commit('clear');
    },
    async setLatestCompanyContractTags({ commit, state }) {
      if (!state.companyContractTags.length) {
        // 最新版を設定する。
        await CompanyContractTagQuery.getAllCompanyContractTag().then(res => {
          commit('setCompanyContractTags', res.data.data);
        });
      }
    },
    async createCompanyContractTag({ commit }, payload) {
      await CompanyContractTagCreate.createCompanyContractTag(payload.companyContractTagId, payload.companyContractTagName);
    },
    async bulkCreateNotExistCompanyContractTasg({ commit, dispatch }, payload) {
      await CompanyContractTagCreate.bulkCreateNotExistCompanyContractTasg(payload.companyContractTags).catch(error => {
        dispatch(
          'message/setErrorMessage',
          {
            message: error.response.data.error ? error.response.data.error : 'タグの保存に失敗しました'
          },
          { root: true }
        );
      });
    },
    updateCompanyContractTag({ commit, dispatch }, payload) {
      CompanyContractTagUpdate.updateCompanyContractTag(payload.companyContractTagId, payload.companyContractTagName).catch(error => {
        dispatch(
          'message/setErrorMessage',
          {
            message: error.response.data.error ? error.response.data.error : 'タグの更新に失敗しました'
          },
          { root: true }
        );
      });
    },
    deleteCompanyContractTag({ commit }, payload) {
      CompanyContractTagUpdate.deleteCompanyContractTag(payload.companyContractTagId);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/company_contract_tag.js